// A custom hello.js module to connect to Xylem's Keycloak implementation.
// see: https://github.com/MrSwitch/hello.js/blob/master/modules.md
const XYLEM_CONFIG = {
    baseUri: 'https://cloudfront-gcdev.xylem-cloud.com/xcloud/auth',
    realm: 'xcloud',
    clientId: '44b9afd7-eefe-4a6f-8097-d22e500a7305',
    scopes: 'openid profile email devicepilot',
};
export default function init(hello) {
    const base = `${XYLEM_CONFIG.baseUri}/realms/${XYLEM_CONFIG.realm}/protocol/openid-connect`;
    const xylemModule = {
        name: 'Xylem-Cloud',
        oauth: {
            version: 2,
            auth: `${base}/auth`,
            grant: `${base}/token`,
        },
        base,
        scope: { basic: XYLEM_CONFIG.scopes },
        scope_delim: ' ',
        login(p) {
            // keycloak expects a nonce parameter; this is not verified by us.
            p.qs.nonce = (Math.random() * 1e12).toString(36); // eslint-disable-line no-param-reassign
        },
        get: {
            userinfo: `${base}/userinfo`,
        },
        xhr(p, qs) {
            // keycloak expects the access token as a bearer header token
            /* eslint-disable no-param-reassign */
            const token = qs.access_token;
            delete qs.access_token;
            p.headers.Authorization = `Bearer ${token}`;
            /* eslint-enable no-param-reassign */
            return true;
        },
    };
    hello.init({ xylem: xylemModule });
    hello.init({ xylem: XYLEM_CONFIG.clientId }, { redirect_uri: '/oauth.html' });
}
